import { booleanAttribute, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { AeIconsComponent, IconList } from '@aeShared/components/ae-icons/ae-icons.component';

export type ButtonType = 'primary' | 'secondary' | 'outline' | 'link' | 'block' | 'unblock';
export type ButtonSize = 'md' | 'sm' | 'lg' | 'xs';

@Component({
  selector: 'app-ae-button',
  standalone: true,
  imports: [NgClass, AeIconsComponent],
  templateUrl: './ae-button.component.html',
  styleUrl: './ae-button.component.scss',
})
export class AeButtonComponent {
  @Input() buttonType: ButtonType = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() loading: boolean | null = false;
  @Input() icon!: IconList;
  @Input() onlyIcon = false;
  @Input() disabled = false;
  @Input() type = 'submit';
  @Input({ transform: booleanAttribute }) fullWidth = false;
}
